// extracted by mini-css-extract-plugin
export default {"Spinner":"SpinnerLoad_Spinner__5NnGz","animatetop":"SpinnerLoad_animatetop__OF8f2"};